import { Pipe, PipeTransform } from '@angular/core';
import { UtilsService } from '../services/utils.service';

@Pipe({
  name: 'cabinOrdinalName'
})
export class CabinOrdinalNamePipe implements PipeTransform {

  transform(value: number, args?: any): any {
    return UtilsService.getOrdinalNumber( value ) + ' Cabin';
  }

}
